import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-whats-next',
  templateUrl: './whats-next.component.html',
  styleUrls: ['./whats-next.component.scss']
})
export class WhatsNextComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
